<template>
  <div>
    <!-- 팝업 오버레이 -->
    <div class="popup-overlay" :class="{ 'is-open': isPopupOpen }" @click="closePopup">
      <div class="popup-content" @click.stop>
        <!-- 사이드 배너 (팝업과 함께 이동) -->
        <button
          class="side-banner"
          :class="{ 'is-active': isPopupOpen }"
          @click="isPopupOpen ? closePopup() : openPopup()"
        >
          <span class="banner-text-vertical">{{ bannerData.text }}</span>
          <span class="banner-arrow">{{ isPopupOpen ? '←' : '→' }}</span>
        </button>

        <!-- 팝업 프레임 -->
        <div class="popup-frame">
          <img src="@/assets/popup/popup.png" alt="팝업 이미지" class="popup-image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideBanner',
  data() {
    return {
      bannerData: {
        text: 'LOCATION'
      },
      isPopupOpen: false
    }
  },
  mounted() {
    window.addEventListener('open-side-popup', this.openPopup)
  },
  beforeUnmount() {
    window.removeEventListener('open-side-popup', this.openPopup)
  },
  methods: {
    openPopup() {
      this.isPopupOpen = true
      document.body.style.overflow = 'hidden'
    },
    closePopup() {
      this.isPopupOpen = false
      document.body.style.overflow = ''
    }
  }
}
</script>

<style scoped>
/* 팝업 오버레이 */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  pointer-events: none;
  transition: background 0.4s ease;
}

.popup-overlay.is-open {
  background: rgba(0, 0, 0, 0.6);
  pointer-events: auto;
}

.popup-content {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 40px;
  transform: translateX(calc(-100% - 40px));
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: auto;
}

.popup-overlay.is-open .popup-content {
  transform: translateX(0);
}

/* 사이드 배너 */
.side-banner {
  position: absolute;
  right: -72px;
  top: 50%;
  transform: translateY(-50%);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  width: 72px;
  padding: 60px 18px;

  background: var(--rayone-primary);
  border: none;
  border-radius: 0 12px 12px 0;
  box-shadow: 4px 0 30px rgba(0, 0, 0, 0.15);

  text-decoration: none;
  cursor: pointer;
  transition: background 0.3s ease;
}

.side-banner:hover,
.side-banner.is-active {
  background: var(--rayone-primary);
}

.banner-text-vertical {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-family: var(--font-paperlogy);
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 5px;
  color: #fff;
}

.banner-arrow {
  font-size: 18px;
  color: #fff;
}

/* 팝업 프레임 */
.popup-frame {
  background: var(--rayone-primary);
  padding: 16px;
  border-radius: 0 16px 16px 0;
  box-shadow: 10px 0 40px rgba(0, 0, 0, 0.3);
}

.popup-image {
  display: block;
  height: 85vh;
  width: auto;
  border-radius: 12px;
  object-fit: contain;
}
</style>
